<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title" v-if="getModalData.id && form.role == 'Monitor'">Edit Monitor</div>
      <div class="title" v-if="getModalData.id && form.role != 'Monitor'">Edit User</div>
      <div class="title" v-if="!getModalData.id && getModalData.role == 'Monitor'">Add Monitor</div>
      <div class="title" v-if="!getModalData.id && getModalData.role != 'Monitor'">Add User</div>
    </div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent" v-if="getAuthUser.role_name == 'Admin' && rolesOptions">
        <label class="form__label">Role</label>
        <vue-select id="userRole" v-model="form.role" :options="rolesOptions"></vue-select>
      </div>
      <div class="form__bent" v-if="form.role.toLowerCase() == 'observer'">
        <label class="form__label">Partner Organisation</label>
        <vue-select id="userPartnersOptions" :settings="{multiple: true}" v-model="form.partners_ids" :options="partners"></vue-select>
      </div>
      <div class="form__bent" v-if="getModalData.id && this.form.role == 'Monitor'">
        <label class="form__label">Monitor ID</label>
        <input type="text" class="form__field" v-model="form.mid"/><span class="form__del"></span>
      </div>
      <div class="form__bent">
        <label class="form__label">Email</label>
        <input type="email" class="form__field" v-model="form.email"/><span class="form__del"></span>
      </div>
      <div class="form__bent">
        <label class="form__label" v-if="form.role == 'Partner Organisation'">Name Of Organization</label>
        <label class="form__label" v-else>Name</label>
        <input type="text" class="form__field" v-model="form.name"/><span class="form__del"></span>
      </div>
      <div class="form__bent">
        <label class="form__label">Password</label>
        <div class="form__password">
          <input type="password" class="form__field" v-model="form.password"/><span class="form__eye"><span class="form__show"></span></span><span class="form__del"></span>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Repeat Password</label>
        <div class="form__password">
          <input type="password" class="form__field" v-model="form.password_confirmation"/>
          <span class="form__eye"><span class="form__show"></span></span><span class="form__del"></span>
        </div>
      </div>
      <div class="form__bent" v-if="getAuthUser.role_name == 'Admin' && form.role == 'Monitor'">
        <label class="form__label">Partner Organisation</label>
        <vue-select id="userPartner" v-model="form.partner_id" :options="getPartnersOptions()"></vue-select>
      </div>
      <div class="form__bent">
        <label class="form__label">Country</label>
        <vue-select id="userCountry" v-model="form.country_id" :options="getCountriesOptions()"></vue-select>
      </div>
      <div class="form__bent">
        <label class="form__label">Phone Number</label>
        <div class="form__inlet">
          <input type="text" class="form__field form__field-code" v-model="phone_prefix"/>
          <input type="text" class="form__field" v-model="form.phone"/><span class="form__del"></span>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Active/Inactive</label>
        <div class="form__brace">
          <div class="form__variant">
            <input v-model="form.status" value="1" type="radio" id="1-1" class="form__radio"/>
            <label for="1-1" class="form__radio-label">Active</label>
          </div>
          <div class="form__variant">
            <input v-model="form.status" value="0" type="radio" id="1-2" class="form__radio"/>
            <label for="1-2" class="form__radio-label">Inactive</label>
          </div>
        </div>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit" v-if="getModalData.id">Save</button>
        <button class="btn" type="submit" v-else>Add</button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "ModalUser",
    computed: {
      ...mapGetters([
        'getRoles',
        'getModalData',
        'getCountriesOptions',
        'getPartnersOptions',
        'getRolesOptions',
        'getAuthUser',
        'getPartnersOptionsForModal'
      ]),
      partners () {
        return this.getPartnersOptionsForModal
      }
    },
    data() {
      return {
        form: {
          mid: '',
          email: '',
          name: '',
          password: '',
          password_confirmation: '',
          role: '',
          partner_id: 0,
          partners_ids: [],
          country_id: 0,
          phone: '',
          status: 1
        },
        phone_prefix: '',
        rolesOptions: null,
        partnersOptions: null
      }
    },
    watch: {
      'form.role'(val) {
        if (val != 'Monitor')
          this.form.partner_id = null
      },
      phone_prefix(val) {
        if (val.substr(0, 1) != '+')
          this.phone_prefix = '+' + this.phone_prefix
      }
    },
    mounted() {
      this.queryCountries()
      if (this.getModalData.id) {
        this.form.mid = this.getModalData.mid
        this.form.email = this.getModalData.email
        this.form.name = this.getModalData.name
        this.form.country_id = this.getModalData.country_id
        this.form.role = this.getModalData.roles[0].name
        this.form.partner_id = this.getModalData.partner_id
        this.form.partners_ids = this.getModalData.partners.map(item => item.user_id)
        this.form.status = this.getModalData.status
        if (this.getModalData.phone) {
          let val = this.getModalData.phone.split(' ')
          if (val.length > 1) {
            this.phone_prefix = val[0]
            this.form.phone = this.getModalData.phone.substr(val[0].length + 1)
          } else {
            this.phone_prefix = '+'
            this.form.phone = this.getModalData.phone
          }
        }
      } else {
        this.form.role = this.getModalData.role || ''
      }

      if (this.$router.currentRoute.name != 'Monitors')
        this.rolesOptions = ['Admin', 'Partner Organisation', 'Observer']
      else
        this.form.role = 'Monitor'


    },
    methods: {
      ...mapActions([
        'queryCountries',
        'storeUser',
        'updateUser',
        'setToast',
      ]),

      onSubmit() {
        if (this.form.role == 'Monitor' && !this.form.partner_id) {
          this.setToast({message: 'Partner Organisation field is required', status: 'warning'})
          return false
        }

        if (this.form.password && this.form.password != this.form.password_confirmation) {
          this.setToast({message: 'Passwords do not match', status: 'warning'})
          return false
        }

        let data = {
          mid: this.form.mid,
          email: this.form.email,
          name: this.form.name,
          country_id: this.form.country_id,
          role: this.form.role,
          partners_ids: this.form.role.toLowerCase() == 'observer' ? this.form.partners_ids.join(',') : null,
          status: this.form.status,
          phone: this.phone_prefix + ' ' + this.form.phone,
        }

        if (this.form.role == 'Monitor') data.partner_id = this.form.partner_id

        if (this.form.password) {
          data.password = this.form.password
          data.password_confirmation = this.form.password_confirmation
        }

        if (this.getModalData.id) {
          this.updateUser([this.getModalData.id, data])
        } else {
          if (this.form.password)
            this.storeUser(data)
          else
            this.setToast({message: 'Password field is required', status: 'warning'})
        }
      }
    }
  }
</script>

<style scoped>
  .popup { padding: 50px 100px !important }
</style>
